<template>
  <div>
    <logo class="logo"/>
    <div class="user-top-menu">
      <primary-button @click="gotoTickets" cta small  v-if="isGetTicketsVisible">{{ $t('buttons.get_tickets') }}</primary-button>
    </div>
    <h3 class="welcome">{{ $t('headers.welcome', {name: firstName}) }}</h3>
    <div class="logout-wrapper mt-0">
      <secondary-button @click.prevent="logout">
        {{ $t('buttons.logout') }}
      </secondary-button>
    </div>
    <tab-navigation />
  </div>
</template>

<script>
import TabNavigation from './TabNavigation.vue'
import SecondaryButton from '@/components/buttons/SecondaryButton.vue'
import PrimaryButton from '@/components/buttons/PrimaryButton.vue'
import Logo from '@/components/global/Logo.vue'
import {hasMetaValue} from "../../utils";

export default {
  computed: {
    firstName() {
      return this.$store.getters.currentUser.firstName
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    membership () {
      return this.currentUser && this.currentUser.membership
    },
    membershipValid() {
      return this.currentUser && this.currentUser.membership && this.currentUser.membership.valid
    },
    membershipType() {
      return this.membership && this.membership.membershipType
    },
    hasTicketIframe() {
      return this.membershipValid && this.membershipType && hasMetaValue(this.membershipType.metaValues, 'ticket-iframe');
    },
    isGetTicketsVisible() {
      return this.membership && !hasMetaValue(this.membershipType.metaValues, 'get-tickets-hidden');
    },
  },
  components: {
    TabNavigation,
    SecondaryButton,
    PrimaryButton,
    Logo
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(() => {
          // this.$router.go()
          this.$router.push('/signup/login')
        })
    },
    gotoTickets() {
      if (this.hasTicketIframe) {
        this.$router.push('/member-tickets')
        return;
      }

      const ticketsUri = this.$store.getters.ticketsUri;
      let url;
      if (ticketsUri != null) {
        url = new URL(ticketsUri, process.env.FG_TICKETS_APP_URL).href
      } else {
        url = process.env.FG_TICKETS_APP_URL
      }
      window.location = url
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  float: left;
}

.user-top-menu {
  text-align: right;
  min-height: 120px;
  padding-top: 6.5px;
  @media screen and (max-width: 750px) {
    padding-top: 3px;
  }
}
.welcome {
  font-size: 2.5rem;
  text-align: center;
}
.logout-wrapper{
  text-align: center;
  margin-bottom: 20px;
  @media screen and (max-width: 750px) {
    margin-bottom: 20px;
  }
  .logout {
    border-radius: 5px;
    border: 1px solid #485159;
    padding: 2px 18px;
    font-family: $secondary-font-family;
    // font-size: 0.875rem;
    color: #485159;
  }
}
</style>


